import {Component, Input, OnInit} from '@angular/core';
import {Navigable} from '../../../shared/services/navigation.service';

@Component({
  selector: 'app-widget-button',
  templateUrl: './widget-button.component.html',
  styleUrls: ['./widget-button.component.scss']
})
export class WidgetButtonComponent implements OnInit {

  @Input()
  buttonTitleKey: any;

  @Input()
  iconButton: string;


  @Input()
  navigateItem: Navigable;

  @Input()
  buttonDescription: string;

  constructor() { }
  ngOnInit(): void {
  }

  launchNavigation() {
    this.navigateItem.go();
  }
}
